import { PhoneType, CbcResponse, CreditScore, VerificationCodeResponse, CreditAppFormData } from '@/types/cbc';

export class CbcState {
	cbcSuccessResponse: CbcResponse | null = null

	phoneType: PhoneType | null = null

	creditScore: CreditScore | null = null

	isCbcError = false

	isCbcSuccess = false

	isLoading = false

	isCreditScoreUpdated = false

	verificationCodeResponse: VerificationCodeResponse | null = null

	showCreditAppLauncher = false

	addressCount = 0

	employmentCount = 0

	creditAppFormSubmitted = false

	creditAppFormFields: CreditAppFormData = {} as CreditAppFormData;
}
